import register from 'preact-custom-element'
import { useEffect, useState } from 'preact/hooks'
import { emitterProps, globalEmitter } from 'helpers/emitter-event'
import { fetchData, fetchProductsLinked } from 'helpers/fetch'
import PlpCard from 'snippets/plp-card/plp-card'
import CarouselSwiper from 'modules/carousel-swiper/carousel-swiper'
import { getProductTitle } from 'libs/shopify'
import { map } from 'helpers/utils'
import { addClass, removeClass, selectAll } from 'helpers/dom'
import './carousel-card.css'
import { getManyProductsBySKU } from '../../hooks/useStorefront'
import { processSwatchData } from '../../helpers/swatches'

let devtools
if (process.env.NODE_ENV === 'development') {
  devtools = require('preact/devtools')
}

const selectors = {
  CAROUSEL_CARD_CLASS: '.js-carousel-card',
  HIDDEN_CLASS: 'hidden'
}

const fetchProducts = async (handles) => {
  const allFetches = handles.map((handle) => {
    return fetchData(`/products/${handle.handle}?view=ajax`).then((product) => {
      return product
    })
  })
  return Promise.all(allFetches).then((results) => results)
}

/**
 *
 * @param { { source: 'window.carouselProducts' | 'pdp.packages' } } param0
 * @returns
 */
function CarouselCard({ source = 'window.carouselProducts' }) {
  // const dataSource = this.props.datasource || 'window.carouselProducts'
  // console.log(this.props.datasource)
  const [products, setProducts] = useState([])
  const [isFetching, setIsFetching] = useState(false)

  const options = {
    slidesPerView: 'auto',
    spaceBetween: 16,
    freeMode: {
      enabled: true,
      sticky: true
    },
    grabCursor: true,
    speed: 500,
    breakpoints: {
      1024: {
        slidesPerView: 4,
        spaceBetween: 24
      }
    }
  }

  const normalizeProductQuantity = (product) => {
    const quantity = bundleSkus.find(bundle => bundle.sku === product.sku).qty

    return {
      ...product,
      title: quantity > 1 ? product.title + ' x' + quantity.toString() : product.title
    }
  }

  const init = async (handles) => {
    setIsFetching(true)
    let products =
      source === 'pdp.packages'
        ? await getManyProductsBySKU(bundleSkus.map((x) => x.sku)) //
        : await fetchProducts(handles)

    // early exit for default use case
    if (source !== 'pdp.packages' && !handles?.length) {
      setIsFetching(false)
      return
    }

    // additional processing required
    if (source === 'pdp.packages') {
      let gqlData
      try {
        gqlData = await products.json()
      } catch (err) {
        console.error('Could not parse res from carouselCard', gqlData, err)
        setIsFetching(false)
        return
      }
      products = processSwatchData(gqlData.data.search.edges)

      // Filter out products that don't match the child product SKUs
      const filteredProducts = products.filter((prod) =>
        prod.variants.some((variant) =>
          bundleSkus.some((bundle) => bundle.sku === variant.sku)
        )
      )

      const handles = filteredProducts.map((x) => ({ handle: x.handle }))

      products = await fetchProducts(handles)

      products = products.map((product) => normalizeProductQuantity(product))
    }

    const dataProducts = products.filter((product) => product)
    if (dataProducts.length) {
      await fetchProductsLinked(dataProducts)
      setProducts(dataProducts)
    }
    setIsFetching(false)
  }

  const actionClass = (els, action = 'add') => {
    map((el) => {
      if (action === 'add') addClass(selectors.HIDDEN_CLASS, el)
      else removeClass(selectors.HIDDEN_CLASS, el)
    }, els)
  }

  const getShowCarousel = () => {
    const carouselCardList = selectAll(selectors.CAROUSEL_CARD_CLASS)
    globalEmitter.on(emitterProps.cart.update, (value) => {
      if (value?.length > 0) actionClass(carouselCardList)
      else actionClass(carouselCardList, 'remove')
    })
  }

  useEffect(() => {
    init(window.carouselProducts)
    if (window.location.href.includes('/cart')) getShowCarousel()
    setTimeout(() => {
      document.dispatchEvent(new CustomEvent('swym:collections-loaded'))
    }, 1000)
  }, [])

  // do not show swatches if using source 'pdp.packages'
  const showSwatches = source === 'window.carouselProducts'
  const showPrice = showSwatches
  const carouselClass = source === 'pdp.packages' ? 'carousel-swiper-bundle-contains' : 'carousel-swiper-product-recently'

  return (
    !isFetching && (
      <CarouselSwiper
        items={<CarouselCardItem products={products} showSwatches={showSwatches} showPrice={showPrice} />}
        className={carouselClass}
        options={options}
        navigation={true}
      />
    )
  )
}

/**
 *
 * @param { { showSwatches: boolean, products: Array<unknown> } } param0
 * @returns
 */
function CarouselCardItem({ products, showSwatches = true, showPrice = true }) {
  return products.map(
    (product) =>
      product && (
        <swiper-slide className="w-[264px] md:w-1/3 lg:w-1/4">
          <PlpCard
            title={getProductTitle(product.title)}
            subtitle={product.metafields.sizes}
            handle={product.handle}
            imageUrl={[product.featuredImage]}
            price={product.price}
            originalPrice={product.compareAtPriceMin}
            tags={product.tags}
            className="flex h-full flex-shrink-0 flex-col"
            sku={product.sku}
            currentSize={product.metafields?.variantOptions?.currentSize || ''}
            showSwatches={showSwatches}
            showPrice={showPrice}
            variants={product.variants}
          />
        </swiper-slide>
      )
  )
}

register(CarouselCard, 'carousel-card', ['source'])
